import '@theme/gsap'

const SELECT_SELECTOR = '[data-filter-select]'
const TOGGLE_SELECTOR = '[data-filter-select-toggle]'
const PANEL_SELECTOR = '.filter-select__panel'
const OPTION_SELECTOR = '.filter-select__option'
const STATUS_ATTRIBUTE = 'data-filter-select-status'

const PANEL = {
  duration: 0.5,
  ease: 'power2.out'
}

/**
 * @param {HTMLElement} select
 * @returns {boolean}
 */
function isOpen(select) {
  return select.getAttribute(STATUS_ATTRIBUTE) === 'open'
}

/**
 * @param {HTMLElement} select
 * @returns {string}
 */
function closedHeight(select) {
  return window.getComputedStyle(select).height
}

/**
 * @param {HTMLElement} panel
 * @param {string} height
 * @returns {void}
 */
function animatePanel(panel, height) {
  const gsap = window.gsap

  if (!gsap) {
    panel.style.height = height
    return
  }

  gsap.to(panel, {
    height,
    duration: PANEL.duration,
    ease: PANEL.ease,
    overwrite: 'auto'
  })
}

/**
 * @param {HTMLElement} select
 * @param {boolean} open
 * @returns {void}
 */
function setOpen(select, open) {
  const panel = select.querySelector(PANEL_SELECTOR)
  if (!(panel instanceof HTMLElement)) return

  select.setAttribute(STATUS_ATTRIBUTE, open ? 'open' : 'closed')
  select
    .querySelector(TOGGLE_SELECTOR)
    ?.setAttribute('aria-expanded', String(open))

  animatePanel(panel, open ? 'auto' : closedHeight(select))
}

/**
 * @param {HTMLElement} select
 * @param {Event} event
 * @returns {void}
 */
function onSelectClick(select, event) {
  if (!(event.target instanceof Element)) return

  if (event.target.closest(TOGGLE_SELECTOR)) {
    setOpen(select, !isOpen(select))
    return
  }

  if (!event.target.closest(OPTION_SELECTOR)) return

  setOpen(select, false)
}

/**
 * @param {Event} event
 * @returns {void}
 */
function dismissOutside(event) {
  for (const select of document.querySelectorAll(SELECT_SELECTOR)) {
    if (!(select instanceof HTMLElement && isOpen(select))) continue
    if (event.target instanceof Node && select.contains(event.target)) continue

    setOpen(select, false)
  }
}

/**
 * @param {KeyboardEvent} event
 * @returns {void}
 */
function dismissOnEscape(event) {
  if (event.key !== 'Escape') return

  for (const select of document.querySelectorAll(SELECT_SELECTOR)) {
    if (select instanceof HTMLElement && isOpen(select)) setOpen(select, false)
  }
}

/**
 * @param {Event} event
 * @returns {void}
 */
function onDocumentClick(event) {
  dismissOutside(event)

  if (!(event.target instanceof Element)) return

  const select = event.target.closest(SELECT_SELECTOR)
  if (select instanceof HTMLElement) onSelectClick(select, event)
}

function init() {
  document.addEventListener('click', onDocumentClick)
  document.addEventListener('keydown', dismissOnEscape)
}

init()
